import { render, staticRenderFns } from "./ConfirmationDialog.vue?vue&type=template&id=4b58af6a&scoped=true"
import script from "./ConfirmationDialog.vue?vue&type=script&lang=ts"
export * from "./ConfirmationDialog.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmationDialog.vue?vue&type=style&index=0&id=4b58af6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b58af6a",
  null
  
)

export default component.exports